export const STORAGE_SESSION_KEY = 'cie-session-api-key';
